import { Link as RouterLink, useLocation } from "react-router-dom";

export const URL_LANGS = ["en", "fr", "nl", "pt"];

export const stripLangPrefix = (pathname) => {
    const m = pathname.match(/^\/(fr|nl|pt)(?=\/|$)/);
    return m ? pathname.slice(3) || "/" : pathname;
};

export const langFromPath = (pathname) => {
    const m = pathname.match(/^\/(fr|nl|pt)(?=\/|$)/);
    return m ? m[1] : "en";
};

export const localizePath = (path, lang) => {
    if (!lang || lang === "en") return path;
    return path === "/" ? `/${lang}` : `/${lang}${path}`;
};

export function LocalizedLink({ to, ...props }) {
    const { pathname } = useLocation();
    const lang = langFromPath(pathname);
    const localized =
        typeof to === "string" && to.startsWith("/") && !to.includes("#")
            ? localizePath(to, lang)
            : to;
    return <RouterLink to={localized} {...props} />;
}
